export default __webpack_public_path__ + "/dist/images/list-icon.ffd1858c244df91712cf18de634596b5.svg";